import { render, staticRenderFns } from "./dataPanorama.vue?vue&type=template&id=33a4e646&scoped=true"
import script from "./dataPanorama.vue?vue&type=script&lang=js"
export * from "./dataPanorama.vue?vue&type=script&lang=js"
import style0 from "./dataPanorama.vue?vue&type=style&index=0&id=33a4e646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4e646",
  null
  
)

export default component.exports